import React from "react";
import styled from "styled-components";
import ChatModal from "../../GalleryView/Agm/ChatModal";

const Index = ({
  isModalOpen,
  isBigScreen,
  src,
  modal,
  setModal,
  eventId,
  communicateFields,
}) => {
  return (
    <PageWrapper isModalOpen={isModalOpen}>
      <VideoContainer isBigScreen={isBigScreen}>
        <iframe
          title="Digital Event"
          src={src}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={iframeStyle}
        />
      </VideoContainer>

      {modal?.state && (
        <ModalWrapper>
          <ChatModal {...{ modal, setModal, eventId, communicateFields }} />
        </ModalWrapper>
      )}
    </PageWrapper>
  );
};

export default Index;

const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.isModalOpen ? "flex-start" : "center")};
  align-items: flex-start;
  gap: 20px; /* Space between video and modal */

  ${({ theme }) => `
    @media (max-width: 600px) {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  `}
`;

const VideoContainer = styled.div`
  position: relative;
  height: 0;
  overflow: hidden;
  width: ${(props) => (props.isBigScreen ? "60%" : "89%")};
  padding-bottom: ${(props) => `${(8 / 16) * 100}%`};

  ${({ theme }) => `
    @media (max-width: 600px}) {
      width: 100%;
      padding-bottom: 56.25%; /* 16:9 ratio */
    }
  `}
`;

const ModalWrapper = styled.div`
  width: 40%;

  ${({ theme }) => `
    @media (max-width: 600px) {
      width: 100%;
    }
  `}
`;

const iframeStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: "1px solid #ffffff",
  borderRadius: "8px",
};

export const theme = {
  breakpoints: {
    sm: "600px",
    md: "960px",
    lg: "1280px",
    xl: "1920px",
  },
};

// import React, { useState, useEffect } from "react";

// const WebcastrAutoplayWithSound = ({ src }) => {
//   const [playWithSound, setPlayWithSound] = useState(false);

//   useEffect(() => {
//     const enableSound = () => {
//       setPlayWithSound(true);
//       window.removeEventListener("click", enableSound);
//       window.removeEventListener("pointerdown", enableSound); // For mobile
//     };

//     // Attach interaction listeners (click/pointerdown)
//     window.addEventListener("click", enableSound);
//     window.addEventListener("pointerdown", enableSound);

//     return () => {
//       window.removeEventListener("click", enableSound);
//       window.removeEventListener("pointerdown", enableSound);
//     };
//   }, []);

//   const iframeUrl = playWithSound
//     ? `${src}?autoplay=1&muted=0`
//     : `${src}?autoplay=1&muted=1`;

//   return (
//     <iframe
//       key={iframeUrl} // Force re-render when URL changes
//       src={iframeUrl}
//       allow="autoplay; fullscreen"
//       allowFullScreen
//       width="100%"
//       height="500"
//       frameBorder="0"
//       title="WebCastr Stream"
//       style={{ border: "none" }}
//     />
//   );
// };

// export default WebcastrAutoplayWithSound;
